export default class ExamStatusForm {
    public examId: number
    public userExamId: number
    public isStartExam!: boolean
    public isFinishExam!: boolean
}